const ROUTES: any = {
  LANDING: {
    BASE: '/',
  },
  PRICING: {
    BASE: '/pricing',
  },
  PRODUCTS: {
    BASE: '/products',
    PRODUCT: '/products/shipbae',
    INSURANCE: '/products/baeguard',
    GORI_API: '/products/gori-api',
    SHIPBAE_A1: '/products/shipbae-a1',
    GORI_SIGNATURE: '/gori-signature',
    GORI_SIGNATURE_PAGE: '/products/gori-signature',
    BAE: '/products/bae',
  },
  INTEGRATIONS: {
    BASE: '/integrations',
    AMAZON: '/integrations/amazon',
    SHIPSTATION: '/integrations/shipstation',
    SHOPIFY: '/integrations/shopify',
    WOOCOMMERCE: '/integrations/woocommerce',
    MAGENTO: '/integrations/magento',
    WALMART: '/integrations/walmart',
    EBAY: '/integrations/ebay',
    TIKTOK: '/integrations/tiktok',
    TEMU: '/integrations/temu',
  },
  RESOURCE: {
    BASE: '/resources',
    BLOG: '/resources/blog',
    RELEASES: '/resources/releases',
    SHIPPING_CALCULATORS: '/resources/shipping-calculators',
  },
  FREE_TOOLS: {
    BASE: '/free-tools',
    CLAIM_CHECKLIST: '/free-tools/claim-checklist',
    SHIPPING_CALCULATOR: '/free-tools/shipping-calculator',
  },
  PROMOTIONS: {
    BASE: '/promotions',
    MARKETPLACE: '/promotions/marketplace-connections',
    TEMU: '/promotions/temu-referral',
  },
  AUTH: {
    BASE: '/auth',
    ONBOARDING: '/auth/onboarding',
    LOGIN: '/auth/login',
    RETOOL: '/retool/login',
    LOGOUT: '/auth/logout',
    FORGOT_PASSWORD: '/auth/forgot-password',
    NEW_PASSWORD: '/auth/new-password',
    REGISTRATION: '/auth/registration',
    REGISTRATION_REFERRAL: '/auth/register',
    ACTIVE_ACCOUNT: '/auth/active-account',
    PENDING_ACTIVATION: '/auth/pending-activation',
    ACTIVE_USER: '/auth/active-user',
    TRADE_SHOW: '/auth/registration/:name/:location',
    TRADE_SHOW_KMAT_26: '/auth/registration/kmat26',
  },
  DASHBOARD: {
    BASE: '/dashboard',
  },
  ORDERS: {
    BASE: '/orders',
    CREATE: '/orders/create',
  },
  SHIPMENTS: {
    BASE: '/shipments',
  },
  END_OF_DAY: {
    BASE: '/end-of-day',
    OPEN_SHIPMENTS: '/end-of-day/open-shipments',
    CLOSED_SHIPMENTS: '/end-of-day/closed-shipments',
  },
  BATCHES: {
    BASE: '/batches',
  },
  A1: {
    BASE: '/a1-batches',
  },
  CLAIMS: {
    BASE: '/claims',
    POLICY: '/claims/policy',
  },
  REPORTS: {
    BASE: '/reports',
    SHIPMENT: '/reports/shipments',
    RETURN_SHIPMENT: '/reports/return-shipments',
    TRANSACTIONS: '/reports/transactions',
    TRANSACTIONS_ENDING_BALANCE: '/reports/transactions-ending-balance',
    ORDER: '/reports/orders',
    DATA: '/reports/data',
  },
  DEPOSITS: {
    BASE: '/deposits',
  },
  SETTINGS: {
    BASE: '/settings',
    PROFILE: '/settings/profile',
    GENERAL: '/settings/general',
    PAYMENT_PLAN: '/settings/payment-plan',
    USER_MANAGEMENT: '/settings/user-management',
    API_KEYS: '/settings/api-keys',
    SECURITY: '/settings/security',
    SHIPPING_ADDRESSES: '/settings/shipping-addresses',
    PACKAGES: '/settings/packages',
    PRESETS: '/settings/presets',
    LABELS_SLIPS: '/settings/labels-slips',
    INSURANCE: '/settings/insurance',
    CARRIER_ROUTE: '/settings/carrier-route',
    AUTOMATION_RULES: '/settings/automation-rules',
    CONNECTIONS: {
      BASE: '/settings/connections',
      SHIPSTATION: '/settings/connections/shipstation',
      SHOPIFY: '/settings/connections/shopify',
      SHOPIFY_VERIFY: '/settings/connections/shopify/verify',
      WOOCOMMERCE: '/settings/connections/woocommerce',
      MAGENTO: '/settings/connections/magento',
      WALMART: '/settings/connections/walmart',
      EBAY: '/settings/connections/ebay',
      TIKTOK: '/settings/connections/tiktok',
      TIKTOK_VERIFY: '/settings/connections/tiktok/verify',
      TEMU: '/settings/connections/temu',
    },
  },
  SUPPORT: {
    BASE: '/support',
  },
  MAINTENANCE: {
    BASE: '/maintenance',
  },
  SERVICE_TERMS: {
    BASE: '/service-terms',
  },
  PRIVACY_POLICY: {
    BASE: '/privacy-policy',
  },
  AGREEMENT_PAGE: {
    BASE: '/agreement',
  },
  HELP_CENTER: {
    BASE: '/help-center',
    BAE_GUARD: '/help-center/baeguard',
    BAE_GUARD_AUTOMATED: '/help-center/baeguard/automated-insurance',
    REPORT: '/help-center/report',
    MANAGE_SHIPMENT: {
      GORI_SIGNATURE: '/help-center/manage-shipment/gori-signature',
    },
  },
  CONTACT_US: {
    BASE: '/contact-us',
    GENERAL_SUPPORT: '/contact-us/general-support',
  },
  ERROR: {
    BASE: '/error',
    ERROR404: '/error/404',
    ERROR500: '/error/500',
  },
  GLOBAL: {
    BASE: '/global',
    SHOPIFY: '/global/shopify/verify',
    TIKTOK: '/global/tiktok/verify',
    EBAY: '/global/ebay/verify',
  },
  SURVEY: {
    BASE: '/survey',
    BAESURVEY: '/bae-survey',
  },
  SHOW: {
    BASE: '/show',
    CILFLEADFORM: '/show/form/china-show/CILF2025',
  },
  SB_DEMO: {
    BASE: '/demo',
    INTRO_VIDEO: '/demo/intro-video',
    TOPICS: '/demo/topics',
    DEMO_PLAYER: '/demo/demo-player',
  },
  GORI_SIGNATURE: {
    BASE: '/gori-signature',
    METHOD_SELECT: '/gori-signature/select',
    TAKE_PHOTO: '/gori-signature/take-photo',
    UPLOAD_PHOTO: '/gori-signature/upload-photo',
    SCAN: '/gs/:hash',
    HASH: '/gori-signature/:hash',
  },
  ACCEPTANCE: {
    TERMS_U_PIC: '/policy/terms-upic',
    COVERAGE_TERMS_U_PIC: '/policy/coverage/terms-upic',
  },
}

const generateRelativePaths = (section: any) => {
  return Object.fromEntries(
    Object.entries(section)
      .filter(
        ([key, value]) => typeof value === 'string' && !['RELATIVE', 'ABSOLUTE'].includes(key)
      )
      .map(([key, value]: any) => [key, value.replace(`${section.BASE}/`, '') + '/*'])
  )
}

const generateAbsolutePaths = (section: any) => {
  return Object.fromEntries(
    Object.entries(section)
      .filter(
        ([key, value]) =>
          typeof value === 'string' && !['RELATIVE', 'ABSOLUTE', 'BASE'].includes(key)
      )
      .map(([key, value]: any) => [key, value.replace(`${section.BASE}/`, '')])
  )
}

const addPathsRecursively = (section: any, visited = new WeakSet()) => {
  if (typeof section !== 'object' || section === null) return
  if (visited.has(section)) return
  visited.add(section)

  // Generate RELATIVE and ABSOLUTE for the current section if it has a BASE
  if ('BASE' in section && typeof section.BASE === 'string') {
    section.RELATIVE = generateRelativePaths(section)
    section.ABSOLUTE = generateAbsolutePaths(section)
  }

  // Process nested objects
  for (const [key, value] of Object.entries(section) as [string, any][]) {
    // Skip processing the newly added RELATIVE and ABSOLUTE properties
    if (key === 'RELATIVE' || key === 'ABSOLUTE') continue

    if (typeof value === 'object' && value !== null) {
      addPathsRecursively(value, visited)

      // Add reference to nested section with BASE in parent's RELATIVE and ABSOLUTE
      if ('BASE' in value && typeof value.BASE === 'string') {
        // Extract the relative path from the nested BASE
        const relativePath = value.BASE.replace(`${section.BASE}/`, '')

        // Initialize RELATIVE and ABSOLUTE objects if they don't exist
        if (!section.RELATIVE) section.RELATIVE = {}
        if (!section.ABSOLUTE) section.ABSOLUTE = {}

        // Add entry for the nested section
        section.RELATIVE[key] = `${relativePath}/*`
        section.ABSOLUTE[key] = relativePath
      }
    }
  }
}

Object.entries(ROUTES).forEach(([key, section]: any) => {
  addPathsRecursively(section)
})

const FIRST_LAYER_PATHS = [
  ROUTES.DASHBOARD.BASE,
  ROUTES.ORDERS.BASE,
  ROUTES.BATCHES.BASE,
  ROUTES.SHIPMENTS.BASE,
  ROUTES.END_OF_DAY.OPEN_SHIPMENTS,
  ROUTES.END_OF_DAY.CLOSED_SHIPMENTS,
  ROUTES.CLAIMS.BASE,
  ROUTES.REPORTS.BASE,
  ROUTES.A1.BASE,
  ROUTES.DEPOSITS.BASE,
  ROUTES.SUPPORT.BASE,
  ROUTES.SETTINGS.BASE,
  '/admin',
]

const HIDDEN_TOP_BAR_ROUTERS = [ROUTES.CLAIMS.POLICY]
export {ROUTES, HIDDEN_TOP_BAR_ROUTERS, FIRST_LAYER_PATHS}
